import { Loader2, Trash2, Check } from "lucide-react";
import { toast } from "sonner";
import { api, euro, formatApiError } from "@/lib/api";
import { StatusBadge } from "@/components/dashboard/StatusBadge";
import { PaymentsDialog } from "@/components/dashboard/PaymentsDialog";

export const TenantsTable = ({ tenants, properties, loading, onChange }) => {
  const propName = (id) => properties.find((p) => p.id === id)?.nome || "—";

  const markPaid = async (t) => {
    try {
      await api.post(`/tenants/${t.id}/payments`, {});
      toast.success(`Canone di ${t.nome} ${t.cognome} registrato`);
      onChange();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  const remove = async (t) => {
    if (!window.confirm(`Rimuovere ${t.nome} ${t.cognome} e il suo storico pagamenti?`)) return;
    try {
      await api.delete(`/tenants/${t.id}`);
      toast.success("Inquilino rimosso");
      onChange();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <section className="surface overflow-hidden" data-testid="tenants-table">
      <div className="border-b border-slate-200 px-6 py-5"><h2 className="text-lg font-semibold text-[#0f172a]">Inquilini & Pagamenti</h2></div>
      {loading ? (
        <div className="flex justify-center p-10"><Loader2 className="h-5 w-5 animate-spin text-[#1e3a8a]" /></div>
      ) : tenants.length === 0 ? (
        <p data-testid="tenants-empty" className="p-10 text-center text-sm text-slate-500">Nessun inquilino registrato. Aggiungi un immobile e poi un inquilino.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
              <tr><th className="px-6 py-3">Inquilino</th><th className="px-4 py-3">Canone</th><th className="px-4 py-3">Scadenza</th><th className="px-4 py-3">Stato</th><th className="px-6 py-3 text-right">Azioni</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {tenants.map((t) => (
                <tr key={t.id} data-testid={`tenant-row-${t.id}`} className="hover:bg-slate-50/70" style={{ transition: "background-color 150ms" }}>
                  <td className="px-6 py-4"><p className="font-semibold text-[#0f172a]">{t.nome} {t.cognome}</p><p className="text-xs text-slate-500">{propName(t.property_id)}</p></td>
                  <td className="px-4 py-4 font-mono text-[13px]">{euro(t.canone)}</td>
                  <td className="px-4 py-4 text-slate-600">ogni {t.giorno_scadenza} del mese</td>
                  <td className="px-4 py-4"><StatusBadge status={t.status} testid={`tenant-status-badge-${t.id}`} /></td>
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-end gap-2">
                      <button data-testid={`button-mark-paid-${t.id}`} disabled={t.status === "regolare"} onClick={() => markPaid(t)} className="btn-ghost px-3 py-1.5 text-xs"><Check className="h-3.5 w-3.5" />Segna pagato</button>
                      <PaymentsDialog tenant={t} onChange={onChange} />
                      <button data-testid={`button-delete-tenant-${t.id}`} onClick={() => remove(t)} className="p-1.5 text-slate-400 hover:text-[#dc2626]" title="Rimuovi"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
